import { Loading } from "components/shared";
import MySocialIcon from "components/shared/MySocialIcon";
import { useState } from "react";
import { HiPlusCircle } from "react-icons/hi2";
import usePostGenerator from "utils/hooks/usePostGenerator";
import { allowedCommentsNetworks } from "utils/comments";
import { Tooltip } from "components/ui";
import capitalize from "components/ui/utils/capitalize";

const PostArticleSocialNoCreated = ({
    network,
    activeSocialNetwork,
    onCreateNetworkPost,
    posts,
    postGroup
}) => {

    const [ isLoading, setIsLoading ] = useState(false);
    const { generateFromOtherPost, generateEmptyPost, copyFromOtherPost } = usePostGenerator();

    const onCopyPost = () => {
        const networkToCopy = postGroup?.posts?.[0]?.social_network_type; 
        const postToCopy = postGroup?.posts?.[0];

        if (postToCopy) {
            let newPost = copyFromOtherPost(
                network, 
                postToCopy?.description || postGroup?.posts?.find(p => !!p?.description)?.description || undefined, 
                postToCopy?.assets || postGroup?.posts?.find(p => !!p?.assets?.length)?.assets || undefined, 
                postToCopy?.title || postGroup?.posts?.find(e => !!e?.title)?.title || undefined,
                postToCopy?.preferences?.media_product_type || "FEED",
                postToCopy?.cover || undefined,
                postToCopy?.preferences?.video_cover_timestamp_ms || undefined
            );
            newPost = {...newPost?.posts?.[0]}

            if (allowedCommentsNetworks.includes(network) && allowedCommentsNetworks.includes(postToCopy.social_network_type)) {
                newPost.comments_to_create = postToCopy?.comments_to_create;
            }

            onCreateNetworkPost(newPost);
        }
    }

    return (
        <div className={`flex-1 flex items-center justify-center ${activeSocialNetwork == network ? `bg-secondary-500 dark:bg-gray-800 border-b border-bg-secondary-500 dark:border-gray-800` : `!bg-seconndary-200 dark:!bg-gray-700`}`}>
            <Tooltip 
                title={`Create ${capitalize(network)} post`}
                wrapperClass="w-full h-full"
            >
                <div onClick={() => onCopyPost()} className="h-full px-4 shrink-0 flex items-center justify-center h-full group cursor-pointer relative transition-all hover:bg-secondary-400 dark:hover:bg-gray-800 hover:shadow-xl hover:z-[10]">
                    <span className="relative">
                        <MySocialIcon 
                            network={network} 
                            bgColor={network != activeSocialNetwork ? `#666666` : undefined} 
                            wrapperClassName={`!w-6 !h-6 lg:[.fullScreen_&]:!w-8 lg:[.fullScreen_&]:!h-8`}
                            className={`!w-6 !h-6 lg:[.fullScreen_&]:!w-8 lg:[.fullScreen_&]:!h-8 !cursor-pointer transition-all rounded-full ${network != activeSocialNetwork && `grayscale brightness-[2.2] dark:brightness-[0.6]`}`} 
                        />
                        {!isLoading && (
                            <HiPlusCircle 
                                className="transition-all absolute -bottom-1.5 -right-1.5 text-tertiary-400 pointer-events-none text-xl lg:[.fullScreen_&]:!text-xl lg:[.fullScreen_&]:!-bottom-1 lg:[.fullScreen_&]:!-right-1" 
                            />
                        )}
                        {isLoading && (
                            <div className="flex items-center justify-center absolute left-0 top-0 w-full h-full rounded-full">
                                <Loading type="element" size="30" />
                            </div>
                        )}
                    </span>
                    <div className="absolute bottom-0 left-0 w-full h-[1px] bg-gray-100 dark:bg-gray-800"></div>
                </div>
            </Tooltip>
        </div>
    )
}

export default PostArticleSocialNoCreated;